import { useCustomDeleteWorksheetProductMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";
import getLocalString from "constants/Localization";

export default function useDeleteWorksheetProduct() {
  const [mutation, { loading, data, error }] = useCustomDeleteWorksheetProductMutation({
    refetchQueries: ["customGetWorksheetProducts"],
  });
  const [deleteWorksheetProduct, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "deleteWorksheetProduct",
    },
    {
      successMessage: getLocalString("worksheet.delete-product-success"),
      failureMessage: getLocalString("worksheet.delete-product-failure"),
    }
  );

  return [deleteWorksheetProduct, context] as const;
}
